import { MatriceView } from "@/pages/MensaMatricePage";

export default function RfMatricePage() {
  return <MatriceView />;
}
